export default __webpack_public_path__ + "static/media/supply_package_green.ffc287cc.svg";